import { render, staticRenderFns } from "./file-selector.vue?vue&type=template&id=2a0709a1&scoped=true&"
import script from "./file-selector.vue?vue&type=script&lang=js&"
export * from "./file-selector.vue?vue&type=script&lang=js&"
import style0 from "./file-selector.vue?vue&type=style&index=0&id=2a0709a1&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a0709a1",
  null
  
)

export default component.exports